function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import Translate from "react-translate-component";
import BrainkeyInput from "components/Wallet/BrainkeyInputStyleGuide";
import PasswordConfirm from "components/Wallet/PasswordConfirmStyleGuide";
import WalletDb from "stores/WalletDb";
import WalletManagerStore from "stores/WalletManagerStore";
import WalletActions from "actions/WalletActions";
import { connect } from "alt-react";
import SettingsActions from "actions/SettingsActions";
import PropTypes from "prop-types";
import { getWalletName } from "branding";
import { Button, Form, Input } from "bitshares-ui-style-guide";
import counterpart from "counterpart";

class CreateNewWallet extends Component {
  static propTypes = {
    hideTitle: PropTypes.bool
  };

  constructor(props) {
    super();
    this.state = {
      wallet_public_name: "default",
      valid_password: null,
      errors: {
        validBrainkey: false
      },
      isValid: false,
      create_submitted: false,
      custom_brainkey: props.restoreBrainkey || false,
      brnkey: null
    };
    this.validate = this.validate.bind(this);
  }

  onBack(e) {
    e.preventDefault();
    window.history.back();
  }

  onPassword(valid_password) {
    if (valid_password !== this.state.valid_password) this.setState({
      valid_password
    }, this.validate);
  }

  onCustomBrainkey() {
    this.setState({
      custom_brainkey: true
    });
  }

  onBrainkey(brnkey) {
    this.setState({
      brnkey
    }, this.validate);
  }

  onSubmit = e => {
    e.preventDefault();
    let {
      wallet_public_name,
      valid_password,
      custom_brainkey,
      errors
    } = this.state;

    if (!valid_password || errors.wallet_public_name || custom_brainkey && !errors.validBrainkey) {
      return;
    }

    WalletActions.setWallet(wallet_public_name, valid_password, this.state.brnkey);
    SettingsActions.changeSetting({
      setting: "passwordLogin",
      value: false
    });
    this.setState({
      create_submitted: true
    });
  };
  formChange = event => {
    let key_id = event.target.id;
    let value = event.target.value;

    if (key_id === "wallet_public_name") {
      //case in-sensitive
      value = value.toLowerCase(); // Allow only valid file name characters

      if (/[^a-z0-9_-]/.test(value)) return;
    } // Set state is updated directly because validate is going to
    // require a merge of new and old state


    this.state[key_id] = value;
    this.setState(this.state);
    this.validate();
  };

  validate(state = this.state) {
    let errors = state.errors;
    let {
      wallet_names
    } = this.props;
    errors.wallet_public_name = !wallet_names.has(state.wallet_public_name) ? null : `Wallet ${state.wallet_public_name.toUpperCase()} exists, please change the name`;
    let isValid = errors.wallet_public_name === null && state.valid_password !== null;
    if (state.custom_brainkey && isValid) isValid = state.brnkey !== null;
    this.setState({
      isValid,
      errors
    });
  }

  render() {
    let state = this.state;
    let errors = state.errors;
    let has_wallet = !!this.props.current_wallet;

    if (this.state.create_submitted && this.state.wallet_public_name === this.props.current_wallet) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement(Translate, {
        content: "wallet.wallet_created"
      })), /*#__PURE__*/React.createElement(Link, {
        to: "/"
      }, /*#__PURE__*/React.createElement("div", {
        className: "button success"
      }, /*#__PURE__*/React.createElement(Translate, {
        content: "wallet.done"
      }))));
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "wallet-create"
    }, /*#__PURE__*/React.createElement(Form, {
      style: {
        maxWidth: "40rem"
      },
      onSubmit: this.onSubmit,
      onChange: this.formChange,
      noValidate: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid-content",
      style: {
        textAlign: "left"
      }
    }, !this.props.restoreBrainkey ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Translate, {
      component: "p",
      content: "wallet.create_importkeys_text"
    }), /*#__PURE__*/React.createElement(Translate, {
      component: "p",
      content: "wallet.create_text",
      wallet_name: getWalletName()
    })) : null), /*#__PURE__*/React.createElement(PasswordConfirm, {
      onValid: this.onPassword.bind(this)
    }), has_wallet ? /*#__PURE__*/React.createElement(Form.Item, {
      label: counterpart.translate("wallet.name")
    }, /*#__PURE__*/React.createElement("div", {
      className: "no-overflow"
    }, /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Input, {
      tabIndex: 3,
      type: "text",
      id: "wallet_public_name",
      defaultValue: this.state.wallet_public_name
    }), /*#__PURE__*/React.createElement("div", {
      className: "has-error"
    }, errors.wallet_public_name)))) : null, /*#__PURE__*/React.createElement("div", {
      className: "no-overflow"
    }, this.state.custom_brainkey ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Form.Item, {
      label: counterpart.translate("wallet.brainkey")
    }, /*#__PURE__*/React.createElement(BrainkeyInput, {
      tabIndex: 4,
      onChange: this.onBrainkey.bind(this),
      errorCallback: warn => {
        let {
          errors
        } = this.state;
        errors.validBrainkey = warn;
        this.setState({
          errors
        });
      }
    }))) : null, /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      htmlType: "submit",
      disabled: !this.state.isValid
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.create_wallet"
    })), /*#__PURE__*/React.createElement(Button, {
      onClick: this.onBack.bind(this)
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.cancel"
    }))), !this.state.custom_brainkey ? /*#__PURE__*/React.createElement("div", {
      style: {
        paddingTop: 20
      }
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("a", {
      onClick: this.onCustomBrainkey.bind(this)
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "wallet.custom_brainkey"
    })))) : null));
  }

}

CreateNewWallet = connect(CreateNewWallet, {
  listenTo() {
    return [WalletManagerStore];
  },

  getProps() {
    return WalletManagerStore.getState();
  }

});

class WalletCreate extends Component {
  render() {
    if (WalletDb.getWallet() && this.props.children) return /*#__PURE__*/React.createElement("div", null, this.props.children);
    return /*#__PURE__*/React.createElement(CreateNewWallet, this.props);
  }

}

const CreateWalletFromBrainkey = props => {
  const wallet_types = /*#__PURE__*/React.createElement(Link, {
    to: "/help/introduction/wallets"
  }, counterpart.translate("wallet.wallet_types"));
  const backup_types = /*#__PURE__*/React.createElement(Link, {
    to: "/help/introduction/backups"
  }, counterpart.translate("wallet.backup_types"));

  if (!props.nested) {
    return /*#__PURE__*/React.createElement("div", {
      className: "grid-container",
      style: {
        paddingTop: 30
      }
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "settings.backup_brainkey",
      component: "h3"
    }), /*#__PURE__*/React.createElement(Translate, {
      content: "settings.restore_brainkey_text",
      component: "p",
      style: {
        maxWidth: "40rem"
      }
    }), /*#__PURE__*/React.createElement(Translate, {
      component: "p",
      style: {
        paddingBottom: 10
      },
      wallet: wallet_types,
      backup: backup_types,
      content: "wallet.read_more"
    }), /*#__PURE__*/React.createElement(WalletCreate, _extends({
      restoreBrainkey: true
    }, props)));
  }

  return /*#__PURE__*/React.createElement(WalletCreate, _extends({
    restoreBrainkey: true
  }, props));
};

export { WalletCreate, CreateWalletFromBrainkey };